<div class="stepper"
  [ngClass]="[stepperBuilder.orientation === 'horizontal' ? ' flex-1 flex flex-row gap-4' : 'flex flex-col gap-4', stepperBuilder.classes?.wrapper || '']">
  <ng-container *ngFor="let item of stepperBuilder.items">
    <sm-stepper-step [item]="item" [active]="item.value === (activeIndex$ | async)"
      [onActivate]="activateStep.bind(this)">
      <div [ngClass]="[' flex-1', stepperBuilder.classes?.content || '' ]">
        <ng-container #dynamicHost></ng-container>
      </div>
    </sm-stepper-step>
  </ng-container>

  <!-- Footer -->
  <ng-container *ngIf=" activeIndex$ | async as activeStep">
    <div class="flex flex-1 justify-between mt-4 w-full items-center">
      <p-button type="button" (click)="activateStep(activeStep - 1)" [disabled]="activeStep <= 1">
        {{ 'common.previous' | translate }}
      </p-button>

      <div class="flex gap-2">
        <p-button type="button" (click)="activateStep(activeStep + 1)"
          [disabled]="activeStep >= stepperBuilder.items.length">
          {{ 'common.next' | translate }}
        </p-button>
        <ng-container *ngFor="let action of footerActions | async">
          <p-button [label]="action.label | translate" [severity]="action.severity || 'secondary'"
            (click)="action.onClick()" [disabled]="(action.disabled | async) ?? false"
            [loading]="(action.loading | async) ?? false"></p-button>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>